﻿import React from 'react';

class WizardItemInformationMessage extends React.Component {

	constructor(props) {

		super(props);
		this.state = {
			selected: null
		};

		this.clickGoBack = this.clickGoBack.bind(this);

	}

	clickGoBack(e) {
		e.preventDefault();

		this.props.setPreviousQuestion(this.props.currentStep);
		this.props.goToStep(this.props.currentStep - 1);
	}

	render() {
		const useTagArrow_16x16 = '<use xlink:href="/dist/svgsprite/icons.svg#Arrow_No-stem_16x16"/>';
		const ArrowStem_16x16 = '<use xlink:href="/dist/svgsprite/icons.svg#Arrow_16x16"/>';

		return (
			<div className="wizard-item">
				<div className="text" dangerouslySetInnerHTML={{ __html: this.props.data.BodyText }} />

				<div className="wizard-tool__button">
					{this.props.data.ButtonLink &&
						<a href={this.props.data.ButtonLink.Url} className="button u-margin-top-small">
							<span>{this.props.data.ButtonLink.Title}</span> <svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" dangerouslySetInnerHTML={{ __html: useTagArrow_16x16 }} />
						</a>
					}
				</div>
				<div>
					{this.props.data.IsBackLinkVisible &&
						<a href="#" onClick={this.clickGoBack} className="u-margin-top-small trumpet go-back-link">
							<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" dangerouslySetInnerHTML={{ __html: ArrowStem_16x16 }} />
							<span>{this.props.data.BackLinkText}</span>
						</a>
					}
				</div>
			</div>
		)
	}
}

export default WizardItemInformationMessage;